import '../../../styles/Auth/report.css';

const CustomerReport = () => {
    return (
        <div className="customer-report">
            <h2>Customer Report</h2>
            {/* Customer report content goes here */}
        </div>
    );
};

export default CustomerReport;
